import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  empty: {
    id: 'studio.kL7Utu',
    defaultMessage: 'You haven’t logged in to this app yet.',
  },
  error: {
    id: 'studio.ueJswO',
    defaultMessage: 'There was a problem loading the app details.',
  },
  loading: {
    id: 'studio.4Mn6/Y',
    defaultMessage: 'Loading app account…',
  },
  storePage: {
    id: 'studio.W1r0Vu',
    defaultMessage: 'Store page',
  },
  deleteBody: {
    id: 'studio.rV6IqG',
    defaultMessage: 'Are you sure you want to delete this app account?',
  },
  deleteTitle: {
    id: 'studio.jG4bcj',
    defaultMessage: 'Confirm account deletion',
  },
  deleteError: {
    id: 'studio.Lw/3Ki',
    defaultMessage: 'There was a problem deleting your app account. Please try again.',
  },
  deleteSuccess: {
    id: 'studio.AELJdn',
    defaultMessage: 'App account deleted successfully',
  },
  cancel: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  delete: {
    id: 'studio.wyxJrL',
    defaultMessage: 'Delete account',
  },
  roleLabel: {
    id: 'studio.c35gM5',
    defaultMessage: 'Roles',
  },
  roleHelp: {
    id: 'studio.fakWI1',
    defaultMessage: 'The app doesn’t provide descriptions for these roles',
  },
  nameLabel: {
    id: 'studio.dOQCL8',
    defaultMessage: 'Display name',
  },
  nameHelp: {
    id: 'studio.zZgIyO',
    defaultMessage: 'The display name which is exposed to the app',
  },
  nameRequired: {
    id: 'studio.l1ukuE',
    defaultMessage: 'A display name is required',
  },
  emailLabel: {
    id: 'studio.sy+pv5',
    defaultMessage: 'Email',
  },
  emailHelp: {
    id: 'studio./EMSX/',
    defaultMessage: 'The email address which is exposed to the app',
  },
  emailInvalid: {
    id: 'studio.y9L/B3',
    defaultMessage: 'This needs to be a valid email address',
  },
  emailRequired: {
    id: 'studio.KssJcX',
    defaultMessage: 'An email address is required',
  },
  submit: {
    id: 'studio.jvo0vs',
    defaultMessage: 'Save',
  },
  submitError: {
    id: 'studio.qm1D4w',
    defaultMessage: 'There was a problem',
  },
  ssoTitle: {
    id: 'studio.RoE66d',
    defaultMessage: 'Single sign on accounts',
  },
  picture: {
    id: 'studio.wvoA3H',
    defaultMessage: 'Picture',
  },
  selectFile: {
    id: 'studio.W9mcKw',
    defaultMessage: 'Select a file',
  },
  pictureDescription: {
    id: 'studio.FGdxVQ',
    defaultMessage: 'The picture to use for your public profile.',
  },
});
